import type {ReactElement, ReactNode} from 'react';
import React from 'react';
import styles from './suboption.module.scss';

interface SuboptionProps {
  className?: string;
  children: ReactNode;
}

export function Suboption({className = '', ...props}: SuboptionProps): ReactElement<any> | null {
  return <ul className={`${styles.container} flex-v-row ${className} spacing-p-t-3 spacing-p-b-3 spacing-p-r-3 spacing-p-l-3`}>{props.children}</ul>;
}
